/* This file was generated by running "node scripts/generateTranslations.js". */
/* Created: 2025-02-20 15:19:27 */

const Keys = {
  titleExpired: 'titleExpired',
  titleIsAboutToExpire: 'titleIsAboutToExpire',
  sessionExpiredText: 'sessionExpiredText',
  sessionIsAboutToExpire: 'sessionIsAboutToExpire',
  buttonExpired: 'buttonExpired',
  buttonRefresh: 'buttonRefresh'
}; export default Keys;